import api from 'api'
import Constants from 'Constants'

const { SERVER_PORTAL_URL } = Constants

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getAddressSuggestList: build.query({
      query: ({ search }) => ({
        url: `${SERVER_PORTAL_URL}/api/v1/map/suggest?search=${encodeURIComponent(search)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetAddressSuggestListQuery } = extendedApi
